import { Injectable, inject } from "@angular/core";
import { DocViewerHandlerService } from "./documentViewer.service";
import { PhotoViewerService } from "./photoViewerService.service";
import { isDocument, isImage } from "./viewer.util";
import { Subject, of } from "rxjs";
import { ViewFileInputData } from "./viewer.model";
import { Events } from "app/shared/common/utils/Events";
import { FILE_VIEW_DIALOG } from "app/shared/components/file-view-dialog/file-view-dialog.constant";
import { UtilCommon } from "app/shared/common/utils/UtilCommon";
import jsPDF from "jspdf";

@Injectable({ providedIn: "root" })
export class FileViewerPlaygroundService {
    private _documentViewerService = inject(DocViewerHandlerService);
    private _photoViewerService = inject(PhotoViewerService);
    public triggerDialogDownload$ = new Subject<any>();
    private listData: any[];

    constructor() {
        Events.subscribe(FILE_VIEW_DIALOG.PREVIOUS, (index) => {
            const preFile = UtilCommon.isArray(this.listData, true) && index >= 0
                ? this.listData[index] : null;
            if (preFile) {
                Events.publish(FILE_VIEW_DIALOG.IS_SHOW_NEXT, preFile?.index < this.listData.length - 1 ? true : false);
                Events.publish(FILE_VIEW_DIALOG.IS_SHOW_PRE, preFile?.index > 0 ? true : false);
                this.viewFileObs(preFile, null);
            }
        });

        Events.subscribe(FILE_VIEW_DIALOG.NEXT, (index) => {
            const nextFile = UtilCommon.isArray(this.listData, true) && index < this.listData.length
                ? this.listData[index] : null;
            if (nextFile) {
                Events.publish(FILE_VIEW_DIALOG.IS_SHOW_NEXT, nextFile?.index < this.listData.length - 1 ? true : false);
                Events.publish(FILE_VIEW_DIALOG.IS_SHOW_PRE, nextFile?.index > 0 ? true : false);
                this.viewFileObs(nextFile, null);
            }
        });
    }

    // data: name, identifier, typeCode UpLoadProfileEnum, index
    public viewFileObs(data: ViewFileInputData, listData: Array<ViewFileInputData> = []) {
        if (listData) {
            this.listData = listData;
            Events.publish(FILE_VIEW_DIALOG.IS_SHOW_NEXT, UtilCommon.isArray(listData, true) && listData.length > 1 && data?.index === 0 ? true : false);
            Events.publish(FILE_VIEW_DIALOG.IS_SHOW_PRE, UtilCommon.isArray(listData, true) && listData.length > 1 && data?.index > 0 ? true : false);
        }

        let obs = of(null);
        if (!data) { return }
        const fileSelected = data;
        if (isDocument(fileSelected.name)) {
            return this._documentViewerService.openViewerObs(data, (action) => {
                if (action === 'FAILED') {
                    this.triggerDialogDownload$.next(true);
                }
            })
        } else if (isImage(fileSelected.name)) {
            return this._photoViewerService.openViewerObs(data,listData)

        }
        return obs;
    }

    public viewDocumentFile(data: ViewFileInputData) {
        const fileSelected = data;
        return this._documentViewerService?.openViewerObs(data)
    }

    public getLoadingStatus$(data: any) {
        const fileSelected = data;
        if (isDocument(fileSelected?.name)) {
            return this._documentViewerService.loading.asObservable();
        }
        return this._photoViewerService.loading.asObservable();
    }

    public convertToPDF(text: string) {
        const doc = new jsPDF();
        // Set font size small enough to fit your text
        // Set font size and margins
        const fontSize = 12;
        doc.setFontSize(fontSize);
        const margin = 20; // 20mm margins
        const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();

        // Split text into lines
        const lines = doc.splitTextToSize(text, doc.internal.pageSize.width - 2 * margin);

        // Add text and pages as necessary
        let cursorY = margin;
        for (let line of lines) {
            if (cursorY + fontSize > pageHeight - margin) {
                doc.addPage();
                cursorY = margin;
            }
            doc.text(line, margin, cursorY);
            cursorY += fontSize;
        }

        // Add text to the document
        return doc.output('blob');
        // Emit or store the PDF blob for viewing
    }
}